export const Language = {
  ENGLISH: 'ENGLISH',
  FRENCH: 'FRENCH',
  HINDI: 'HINDI',
  PUNJABI: 'PUNJABI',
  MANDARIN: 'MANDARIN',
};
